import service, { get, post } from '@/utils/request';


// 基础路径
const baseURL = service.defaults.baseURL;

/**
 * 接口地址
 */
export const customerApi = {
    /**
     * 客服列表
     */
    list: `${baseURL}/api/visitor/Customer/list`
};


/**
 * 接口服务
 */
const customerService = {
    /**
     * 客服列表
     */
    list: async () => {
        const res = await get(customerApi.list);
        return res as { code: number; state: string; message?: string; data: any };
    }
};

export default customerService;